<template>
  <div class="cont" id="brandClassroom3">
    <div class="inner">
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
        style="height:32px;width:151px;margin-left:38px;margin-bottom:13px"
        :src="require('@/assets/image/brandClassroom/brandClassroom3/img1.png')"
        :fit="fit"
      ></el-image>
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
        style="height:16px;width:164px;margin-left:25px;margin-bottom: 31px"
        :src="require('@/assets/image/brandClassroom/brandClassroom3/img2.png')"
        :fit="fit"
      ></el-image>
      
      <el-image
        :class="animate == true ? 'animate__animated animate__fadeInRightBig visibilityShow' :'visibilityHide'"
        style="height:26px;width:122px;margin-left:0px;margin-bottom:0px"
        :src="require('@/assets/image/brandClassroom/brandClassroom3/img3.png')"
        :fit="fit"
      ></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContThree",
  data() {
    return {
      fit: "cover",
      animate: false,
      screenHeight: window.innerHeight || document.documentElement.clientHeight
    };
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    var topPos = document.getElementById("brandClassroom3").offsetTop;

    if (scrollTop + this.screenHeight > topPos) {
      this.animate = true;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var topPos = document.getElementById("brandClassroom3").offsetTop;
      if (scrollTop + this.screenHeight > topPos) {
        this.animate = true;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  height: 368px;
  background-color: pink;
  color: #fff;
  margin: 0 auto;
  position: relative;
  background: url('~@/assets/image/brandClassroom/brandClassroom3/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.inner {
  position: absolute;
  width: 189px;
  height: 117px;
  right: 153px;
  top: 126px;
}
</style>